import { render } from "./jobs.vue?vue&type=template&id=143a1eba&scoped=true"
import script from "./jobs.vue?vue&type=script&lang=js"
export * from "./jobs.vue?vue&type=script&lang=js"

import "./jobs.vue?vue&type=style&index=0&id=143a1eba&lang=less&scoped=true"

import exportComponent from "/home/bula/demo/bula2023/vue/bula2023/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a1eba"]])

export default __exports__